import { render } from "./destination-address.vue?vue&type=template&id=0c156ff8"
import script from "./destination-address.vue?vue&type=script&lang=js"
export * from "./destination-address.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__